var path = 'ilmn-ui-components/dist/inline.template.html';
var html = "<div class=loading-animation-wrapper> <div class=loading-animation-container> <span class=loading-animation-viewport> <span class=loading-animation-bar></span> </span> </div> </div> ";
window.angular.module('ilmn-ui-loading-animation').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-loading-animation/views/inline.template.html
// module id = 35
// module chunks = 0 2